var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.isFullscreen ?'点击退出全屏':'点击展开全屏',"placement":"left-end"}},[_c('div',{staticClass:"screenfull saasIcon",on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.isFullscreen ? '\ueb98' : '\ue8fa')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }